// extracted by mini-css-extract-plugin
export default {"tag":"style_tag__JIvuK","filter":"style_filter__iWOnR","settings":"style_settings__kkqXV","filter_report":"style_filter_report__vE8zL","advertiser":"style_advertiser__HfQaw"};